import {
  useThemeProvider,
  DEFAULT_PAGE_WIDTH,
} from "@towersystems/roam-common-native";
import { useWindowDimensions } from "react-native";
import { Spacings } from "react-native-ui-lib";
import { clamp } from "lodash";

export function useItemSizing() {
  const { spacings } = useThemeProvider();
  const { width: screenWidth } = useWindowDimensions();

  const usablePageWidth = clamp(screenWidth, DEFAULT_PAGE_WIDTH);

  const numColumns = usablePageWidth > 600 ? 3 : 2;

  // get image size based on screen width, subtracting margins, padding and border widths
  const totalImageMarginWidth = (numColumns - 1) * 2 * spacings.s3;

  const imageSize =
    (usablePageWidth - Spacings.s5 * 4 - totalImageMarginWidth) / numColumns;

  return { imageSize, numColumns };
}
